var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIkZKarencja = function SvgIkZKarencja(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.773,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8778"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8775"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "m21.412 6.432 3.361 3.361-3.361 3.361",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8776"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "m6.412 6.432 3.361 3.361-3.361 3.361",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8774"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6355",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2058",
    width: 17,
    height: 18,
    rx: 4.685,
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
};

export default SvgIkZKarencja;